enum SKIN_NAME {
  Standard = 'standard',
  DarkMode = 'dark mode',
  ExpretioXCS = 'Expretio XCS',
  ExpretioRivalis = 'Expretio Rivalis',
  // TODO: it's better to use a proper identificator instead of label and rename `Cargill - Diamond Crystal`
  Cargill = 'Cargill - Diamond Crystal',
}

export type SkinName = ValueOf<typeof SKIN_NAME>;

export const isSkinName = (str: string): str is SkinName => {
  const skins: string[] = Object.values(SKIN_NAME);
  return skins.includes(str);
};

export default SKIN_NAME;
